import * as React from 'react';
import { Avatar, Box, Card, CardActionArea, Typography } from "@mui/material";
import cardActionAreaClasses from '@mui/material/CardActionArea/cardActionAreaClasses';
import { apiBaseUrl } from '../utils/Api/Api';
import { currency } from './building_blocks/Currency';
import { layoutCardRadius } from '../theme/colors';

const OrderCard = ({ order, handleCardClick }) => {
  const statusLabels = {
    open: 'Esperando comerciante aceitar',
    pending: 'Pagamento pendente',
    paid: 'Esperando entregador',
    accepted: 'Esperando entregador',
    courier: 'Em entrega',
    delivered: 'Entregue',
    shipped: 'Entregue',
    done: 'Finalizado',
    failed: 'Pagamento falhou',
    rejected: 'Cancelado',
    canceled: 'Cancelado',
  };

  const providerLogo = order.provider_business_logo && `${apiBaseUrl}${order.provider_business_logo}`;
  const statusLabel = statusLabels[order.status] || order.status;
  const itemCount = order.order_items?.reduce((total, item) => total + Number(item.quantity || 0), 0) || 0;
  const canReview = order.status === 'delivered' || order.status === 'shipped';

  const formatOrderDate = () => {
    const dateMatch = order.date?.match(/^(\d{2})\/(\d{2})\/\d{2} às (\d{2}):(\d{2})/);
    const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    if (dateMatch) {
      const [, day, month, hour, minute] = dateMatch;
      return `${day}/${monthNames[Number(month) - 1]} às ${hour}h${minute}`;
    }

    return order.date;
  };

  return (
    <Card sx={{ alignSelf: 'stretch', borderRadius: layoutCardRadius, overflow: 'hidden' }}>
      <CardActionArea
        data-no-shadow="true"
        onClick={handleCardClick}
        sx={{
          display: 'flex',
          p: 3,
          gap: 2,
          alignItems: 'flex-start',
          [`&:hover .${cardActionAreaClasses.focusHighlight}`]: {
            opacity: '0 !important',
          },
          [`&.${cardActionAreaClasses.focusVisible} .${cardActionAreaClasses.focusHighlight}`]: {
            opacity: 0,
          },
          [`& .${cardActionAreaClasses.focusHighlight}`]: {
            opacity: 0,
            backgroundColor: 'transparent',
          },
        }}
      >
        <Avatar
          src={providerLogo}
          sx={{ width: '40px', height: '40px', bgcolor: '#CFD8DC', flexShrink: 0 }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, flex: 1, minWidth: 0, textAlign: 'left' }}>
          <Typography variant="storeName" sx={{ color: '#263238' }}>
            {order.provider.name}
          </Typography>

          <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '21px', color: '#546E7A' }}>
            {formatOrderDate()} • {currency(order.total_amount)} ({itemCount} {itemCount === 1 ? 'item' : 'itens'})
          </Typography>

          <Box sx={{ display: 'flex', height: '24px', px: 1, alignItems: 'center', borderRadius: layoutCardRadius, bgcolor: 'surface.muted' }}>
            <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '21px', color: '#546E7A' }}>
              {statusLabel}
            </Typography>
          </Box>

          {canReview && (
            <Box
              sx={{
                display: 'flex',
                px: 1.5,
                py: 0.5,
                alignItems: 'center',
                borderRadius: layoutCardRadius,
                border: '1px solid',
                borderColor: 'primary.main',
              }}
            >
              <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, lineHeight: '21px', color: 'primary.main' }}>
                Avaliar pedido
              </Typography>
            </Box>
          )}
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default OrderCard;
